import { useState, useEffect } from "react";

import { BsEyeSlash, BsEye } from "react-icons/bs";

interface EdTextfieldProps {
  label: string;
  id: string;
  type: React.HTMLInputTypeAttribute;
  register?: any;
  error?: String;
  onBlur?: (e: any) => void;
  icon?: any;
  placeholder: string;
  disabled?: boolean;
}

export default function EdTextfield({
  label,
  type,
  id,
  register,
  error,
  onBlur,
  placeholder,
  icon,
  disabled = false,
}: EdTextfieldProps) {
  const [showPassword, setShowPassword] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [localError, setLocalError] = useState(error);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
    if (localError) {
      setLocalError(undefined);
    }
  };

  useEffect(() => {
    setLocalError(error);
  }, [error]);

  return (
    <div className="flex flex-col items-stretch transition-all duration-200 ease-in-out">
      <div className="relative">
        <div className="relative">
          <input
            onBlur={onBlur}
            type={showPassword ? "text" : type}
            id={id}
            placeholder=" "
            disabled={disabled}
            onChange={(e) => {
              handleInputChange(e);
              if (register?.onChange) {
                register.onChange(e);
              }
            }}
            className={`transition-all duration-300 ease-in-out relative w-full h-10 
              ${icon !== undefined ? "px-14" : "px-4"} 
              text-sm
              rounded outline-none peer
              text-black autofill:bg-white bg-white 
              focus:outline-none focus-visible:outline-none 
              disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400  
              focus:ring-1 ring-0.5
              border border-1  
              ${localError 
                ? "border-danger-500 ring-danger-500 focus:ring-danger-500 focus:border-danger-500" 
                : "border-secondaryColor-300 ring-secondaryColor-300 focus:ring-black focus:border-black"}`}
            {...register}
          />

          <span className="absolute transition-all duration-300 ease-in-out border-r cursor-pointer border-r-secondaryColor-400 left-3 top-1/4 stroke-secondaryColor-600 fill-secondaryColor-600 hover:stroke-edblue-600 focus:stroke-edblue-600 hover:fill-edblue-600">
            {icon}
          </span>

          <label
            htmlFor={id}
            className={`absolute
              ${icon !== undefined ? "mx-10 " : ""} 
              left-2 -top-2 z-[1] px-2 text-xs transition-all 
              before:absolute before:top-0 before:left-0 before:z-[-1] before:block 
              before:h-full before:w-full before:bg-white before:transition-all   
              ${disabled ? "text-slate-400" : "text-gray-500"}
              peer-placeholder-shown:top-2.5 
              peer-placeholder-shown:text-sm 
              peer-autofill:-top-2  
              peer-focus:-top-2 
              peer-focus:cursor-default 
              peer-focus:text-xs
              pointer-events-none
              ${!localError 
                ? disabled 
                  ? "focus:text-slate-400 peer-focus:text-slate-400" 
                  : "focus:text-black peer-focus:text-black" 
                : "text-danger-500 focus:text-danger-500 peer-focus:text-danger-500"}`}
          >
            {inputValue ? label : placeholder || label}
          </label>
        </div>

        {type === "password" && (
          <button
            type="button"
            onClick={() => !disabled && setShowPassword(!showPassword)}
            disabled={disabled}
            className={`absolute w-4 transition-all duration-300 ease-in-out right-4 top-1/2 transform -translate-y-1/2 border-none outline-none ring-0 focus:border-none focus:outline-none focus:ring-0 active:border-none active:outline-none active:ring-0 ${
              disabled ? "cursor-not-allowed text-slate-400" : "cursor-pointer text-black"
            }`}
          >
            {showPassword ? <BsEyeSlash /> : <BsEye />}
          </button>
        )}
      </div>
      <span className="self-start w-full p-0 mt-1 text-sm text-left text-danger-700">
        {localError}
      </span>
    </div>
  );
}
